var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('portal', {
    attrs: {
      "to": "next-activity-button"
    }
  }, [_c('div', {
    staticClass: "nextSection"
  }, [_c('next-activity-button', {
    attrs: {
      "onClick": _vm.handleOnActivitySubmit
    }
  }), _vm.displayWrongIcon ? _c('WrongIcon', {
    staticClass: "feedbackIcon",
    attrs: {
      "width": 25,
      "height": 40
    }
  }) : _vm._e(), _vm.displayCorrectIcon ? _c('CorrectIcon', {
    staticClass: "feedbackIcon",
    attrs: {
      "width": 35,
      "height": 40
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }